export enum BulkUploadWizardPageObject {
  WizardContainer = 'bulk-upload-wizard',
  WizardStepper = 'wizard-stepper',
  StepContent = 'step-content',

  StepFileUpload = 'step-file_upload',
  StepDataPreview = 'step-data_preview',
  StepFieldTypes = 'step-field_types',
  StepAssetMatching = 'step-asset_matching',
  StepConfirmation = 'step-confirmation',
  StepProcessing = 'step-processing',
  StepResults = 'step-results',

  Dropzone = 'dropzone',
  DropzoneInput = 'dropzone-input',

  FileUploadHeader = 'file-upload-header',
  FileUploadTitle = 'file-upload-title',
  HeaderActions = 'header-actions',
  DownloadTemplateButton = 'download-template-button',
  RequirementsInfoButton = 'requirements-info-button',
  SupportedFormatsText = 'supported-formats-text',
  TemplateHintText = 'template-hint-text',
  SelectFileButton = 'select-file-button',

  RequirementsDrawer = 'requirements-drawer',
  RequirementsDrawerHeader = 'requirements-drawer-header',
  RequirementsDrawerTitle = 'requirements-drawer-title',
  RequirementsDrawerCloseButton = 'requirements-drawer-close-button',
  RequiredColumnsSection = 'required-columns-section',
  OptionalIdSection = 'optional-id-section',
  MetadataColumnsSection = 'metadata-columns-section',
  DataFormatSection = 'data-format-section',
  EmptyCellsSection = 'empty-cells-section',
  FileSizeSection = 'file-size-section',
  SampleTemplatesSection = 'sample-templates-section',
  DrawerCsvDownloadButton = 'drawer-csv-download-button',
  DrawerXlsxDownloadButton = 'drawer-xlsx-download-button',
}
